import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import {ReactComponent as Edit} from "assets/img/edit.svg";
import {greyishBlue300} from "assets/jss/main";

EditIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number
};

const StyledSvg = styled(Edit)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true &&  {
            stroke: greyishBlue300
        }
    },
}));

export default function EditIcon(props) {
    return <StyledSvg {...props} />
}
